import io from 'socket.io-client'

const createSocket = (path: string, userId: string, room?: string) => {
  const socket = io(import.meta.env.VITE_SERVER, {
    query: {
      expires_in: 100 * 60 * 1000,
    },
    auth: {
      user_id: userId,
      room,
    },
    transports: ['websocket', 'polling'],
    path,
  })
  return socket
}

export default createSocket
